module.exports = __webpack_public_path__ + "img/android_digitalprev.7e4048f3.png";